export const SET_ALL_REQUESTS_FOR_PARTICIPATION =
  "Setzt alle requestForParticipation";
export const SET_CURRENT_REQUEST_FOR_PARTICIPATION =
  "Setzt den/das aktuelle requestForParticipation";
